<template>
  <div class="main-body">
    <div class="header">线上支付结算记录</div>
    <div class="out">

      <div class="search2">


        <div style="float: right">

          <el-select v-model="governmentCode" placeholder="请选择政府"
                     clearable filterable
                     @change="govChange" style="margin-right:5px">
            <el-option
                v-for="item in governmentValue"
                :key="item.governmentCode"
                :label="item.name"
                :value="item.governmentCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" plain @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table" border>

        <el-table-column prop="governmentName" label="政府" width="250"></el-table-column>
        <el-table-column prop="money" label="金额" width="200"></el-table-column>
        <el-table-column prop="startDate" :formatter="timefilter" width="200" label="开始时间"></el-table-column>
        <el-table-column prop="endDate" :formatter="timefilter" width="200" label="结束时间"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="结算时间"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data() {
    return {

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: this.$store.state.tableHeight,

      governmentValue: [],
      governmentCode: '',

    }
  },
  components: {

  },
  created() {
    this.governmentCode = this.$route.query.governmentCode;
    this.init();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {
      this.getGovList();
    },

    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){

                if(this.governmentCode==null || this.governmentCode==''){
                  this.governmentCode = this.governmentValue[0].governmentCode;
                }

                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },
    govChange(val){
      this.governmentCode = val;
    },


    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true


      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        governmentCode: this.governmentCode,
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "SettlementGovernment/AdmPage",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },


  }
}
</script>


<style lang="scss" scoped>

</style>
